export default [
	{
		type: "text",
		id: 1,
		items: [
			{
				id: 1,
				text: "Name des/der Übungsgruppenleiters/-leiterin:",
				type: "medium",
			},
		],
	},
	{
		type: "uni",
		id: 2,
		items: [
			{
				id: 2,
				text: "Die Übungsaufgaben waren klar verständlich.",
			},
			{
				id: 3,
				text: "Die Anforderungen im Übungsbetrieb waren angemessen.",
			},
			{
				id: 4,
				text: "Übung und Vorlesung waren gut aufeinander abgestimmt.",
			},
			{
				id: 5,
				text: "Rückfragen wurden problemlos beantwortet.",
			},
			{
				id: 6,
				text: "Der Übungsgruppenleiter/Die Übungsgruppenleiterin konnte Inhalte gut vermitteln.",
			},
			{
				id: 7,
				text: "Der Übungsgruppenleiter/Die Übungsgruppenleiterin war auf jede Übung gut vorbereitet.",
			},
			{
				id: 8,
				text: "Der Übungsgruppenleiter/Die Übungsgruppenleiterin geht auf Fragen genügend ein.",
			},
		],
	},
	{
		type: "text",
		id: 3,
		items: [
			{
				id: 9,
				text: "Anmerkungen zur Übung:",
			},
		],
	},
];
